module.exports = __webpack_public_path__ + "img/apple-logo.00466177.svg";